import React, { useContext, useMemo } from 'react';
import { SlideOutComp } from '@moderepo/mode-app-components';
import { modeUIContext, selectIsEditingForm } from '@moderepo/mode-ui-state';
import { DeviceConfigContainer } from './DeviceConfigContainer';


interface DeviceConfigPreviewContainerProps {
    readonly projectId: number;

    // All these props are required for identifying the selected device config schema
    readonly deviceId: number;
    readonly firmwareComponentName: string;
    readonly firmwareComponentVersionName: string;

    // These 2 are only available if the user is looking at a user's home device
    readonly context?: {
        readonly userId?: number | undefined;
        readonly homeId?: number | undefined;
    }
}


/**
 * This Component is used for displaying DeviceConfig on the preview panel for preview.
 */
export const DeviceConfigPreviewContainer = (props: DeviceConfigPreviewContainerProps) => {
    const { state:uiState } = useContext(modeUIContext);
    const isEditing = selectIsEditingForm(uiState);

    /**
     * There are no primaryActions needed for this preview panel
     */
    const primaryActions = useMemo(() => {
        return undefined;
    }, []);


    /**
     * There are no secondaryActions needed for this preview panel
     */
    const secondaryActions = useMemo(() => {
        return undefined;
    }, []);


    const slideOutCompContent = useMemo(() => {
        return (
            <DeviceConfigContainer
                className="transparent"
                projectId={props.projectId}
                deviceId={props.deviceId}
                firmwareComponentName={props.firmwareComponentName}
                firmwareComponentVersionName={props.firmwareComponentVersionName}
                userId={props.context?.userId}
                homeId={props.context?.homeId}
            />
        );
    }, [props.context?.homeId, props.context?.userId, props.deviceId, props.firmwareComponentName, props.firmwareComponentVersionName,
        props.projectId]);


    return (
        <SlideOutComp
            primaryActions={primaryActions}
            secondaryActions={secondaryActions}
            compContent={slideOutCompContent}
            contentContainerProps={{
                className: 'slide-out-comp-container',
            }}
            closable
            hideActionBar={isEditing}
        />
    );
};
